import React from "react";
//#region types
import { MoreActionsProps } from "models/propTypes/commonPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import MenuButton from "./menuButton";
import RoundButton from "./roundButton";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const MoreActions: React.FC<MoreActionsProps> = (props) => {
  return (
    <MenuButton
      {...props}
      menuPlacement={"top"}
      button={
        <RoundButton className={cssExports.moreActionsButton}>
          <Icon icon={IconDefinitionConstants.WEllipsisH} />
        </RoundButton>
      }
    />
  );
};

export default MoreActions;
